import script from "./MobCardsContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./MobCardsContainer.vue?vue&type=script&setup=true&lang=js"

import "./MobCardsContainer.vue?vue&type=style&index=0&id=1fb29020&lang=css"

const __exports__ = script;

export default __exports__